import type { TFunction } from "i18next";
import type { DateTime } from "luxon";
import type { PunchSummaryCategory } from "@/utils/models";

export const getDefaultPunchMessage = (t: TFunction, category: PunchSummaryCategory, dayDate: DateTime, departmentName: string): string => {
	const date = dayDate.toFormat("ccc, MMM d");
	switch (category) {
		case "noPunch":
		case "missingPunch":
		case "agency":
			return t("punchSummary.notify.template.noPunch", { date, department: departmentName });
		case "shiftDelta":
			return t("punchSummary.notify.template.shiftDelta", { date, department: departmentName });
		case "callIn":
			return t("punchSummary.notify.template.callIn", { date, department: departmentName });
		default:
			return t("punchSummary.notify.template.generic", { date, department: departmentName });
	}
};
